

import './navigation/animalfriends.mobileNav';
import './navigation/animalfriends.tabletNav';
import './navigation/animalfriends.keyboardNavigation'
import './enquiry/index';
import './claims/index'
import './api/index';
import './shared/index';
import './carousels/index';
import './_animalfriends.scroller';
import './toolTip/index';
import './notifications/index';
import './artifact/index';

import "@lottiefiles/lottie-player";

